import ZagPopover, {ZagPopoverProps} from "~/components/zag/ZagPopover";
import {JSX, splitProps} from "solid-js";
import css from "./popover.module.css"

export interface PopoverProps extends Omit<ZagPopoverProps, 'children'> {
    trigger: JSX.Element,
    content: JSX.Element,
}

export default function Popover(props: PopoverProps) {

    const [_, zagProps] = splitProps(props, [])

    return (
        <ZagPopover {...zagProps}>
            {(api) => (
                <div class={css.root}>
                    <button {...api.getTriggerProps()} class={css.trigger}>
                        {props.trigger}
                    </button>
                    <div {...api.getPositionerProps()}>
                        <div {...api.getContentProps()} class={css.content}>
                            {props.content}
                        </div>
                    </div>
                </div>
            )}
        </ZagPopover>
    )
}
